import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';
import { IBrandProfile } from '../interfaces/brand-profile';
import { IBrandPortal } from '../interfaces/brand-portal';
import { IStateProvince } from '../interfaces/state-province';

@Injectable({
  providedIn: 'root'
})
export class BrandProfileService {

  private brandProfileUrl = '/client/brand-profile/{brandCode}'; 
  private brandWithRegionUrl = '/common/brands/with-regions/{brandCode}'; 
  private statesProvincesUrl = '/client/state-provinces';

  private isSuccess!: boolean; 

  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public resetCurrentBrand(brandCode: string): boolean {
    this.getBrandWithRegion(brandCode)
      .subscribe({
        next: (brandWithRegion) => {
          let envRegion: string = brandWithRegion.envCode || '';
          this.sharedService.setEnvRegion(envRegion);
          this.sharedService.setBaseUrl(brandWithRegion.baseUrl || '');
          // Next, figure out brand profile
          this.getBrandProfile(envRegion, brandCode)
          .subscribe({
            next: (brandProfile) => {
              this.sharedService.setBrandProfile(brandProfile);
              this.isSuccess = true;
            },
            error: (e) => {
              this.isSuccess = false;
            },
            complete: () => {
            }
          })
        },
        error: (e) => {
          this.isSuccess = false;
        },
        complete: () => {
        }
    });
    return this.isSuccess;
  }


  public getBrandProfile(envRegion: string, brandCode: string): Observable<IBrandProfile> {
    let headers = new HttpHeaders();
      // .set('Authorization', this.sharedService.getAppBasicAuth())
      // .set('session-id', sessionId);
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) 
      + this.brandProfileUrl.replace('{brandCode}',brandCode);
      console.log('url',url);
    return this.http.get<IBrandProfile>(url, { headers: headers, responseType: 'json'})
      .pipe(
        catchError(this.sharedService.handleError2<IBrandProfile>('validateCustomer' ))
      )
  }

  // Get one given brand with its parent region from Walletron Portal (PostgreSQL)
  public getBrandWithRegion(brandCode: string): Observable<IBrandPortal> {
    // console.log('brandService: ', 'inside getBrandWithRegion');
    let url = this.sharedService.getPortalBaseUrl()
       + this.brandWithRegionUrl.replace('{brandCode}', brandCode);
    return this.http.get<IBrandPortal>(url, {responseType: 'json'})
    .pipe(
        catchError(this.sharedService.handleError2<IBrandProfile>('validateCustomer' ))
      )
  }  

  // Get a list of states | provinces
  public getStatesProvinces(): Observable<IStateProvince[]> {
    let envRegion: string = this.sharedService.getEnvRegion(); 
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) 
      + this.statesProvincesUrl;
    return this.http.get<IStateProvince[]>(url, {responseType: 'json'})
    .pipe(
        catchError(this.sharedService.handleError2<IStateProvince[]>('validateCustomer' ))
      )
  }  




}
